// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__t7v6x","xs":"avatar_xs__-53rl","sm":"avatar_sm__O4LJX","md":"avatar_md__HWHSH","lg":"avatar_lg__ERhgO","invert":"avatar_invert__prMjj"};